import { ref } from 'vue';

const message = ref('');
const isError = ref(false);
const visible = ref(false);
let timer: ReturnType<typeof setTimeout> | undefined;

export function useToast() {
  function toast(text: string, err = false) {
    message.value = text;
    isError.value = err;
    visible.value = true;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      visible.value = false;
    }, 2800);
  }
  return { message, isError, visible, toast };
}
